import React from "react";
import { Loader } from "../Loader/Loader";
import { Box } from "@mui/material";
import Styles from "./CommonLoader.module.scss";
const CommonLoader = ({ openLoader }) => {
  return (
    <Box
      className={Styles.loaderContainer}
      component="div"
      // sx={{ display: openLoader ? "flex" : "none" }}
    >
      <Loader color="#03d697" />
    </Box>
  );
};

export default CommonLoader;
